import { ethers } from 'ethers'
import { UNI_V2_ROUTER } from '../addresses'
import { UNI_V2_ROUTER_ABI } from '../abi'
import { v2Path } from '../path'
import type { Adapter, ExecuteArgs } from './types'
import type { RouteCandidate } from '../types'

/**
 * Uniswap v2 — the same shape as Aerodrome with a plain token path, and the
 * same rule: always the `SupportingFeeOnTransferTokens` variant.
 */
const iface = new ethers.utils.Interface(UNI_V2_ROUTER_ABI as unknown as string[])

export const uniV2Adapter: Adapter = {
  spender(args: ExecuteArgs): string | null {
    return args.tokenIn.isNative ? null : UNI_V2_ROUTER
  },

  async buildTx(args: ExecuteArgs): Promise<ethers.PopulatedTransaction> {
    const candidate = args.quote.candidate as RouteCandidate
    const path = v2Path(candidate)
    const amountIn = ethers.BigNumber.from(args.quote.amountIn.toString())
    const minOut = ethers.BigNumber.from(args.minOut.toString())
    const deadline = ethers.BigNumber.from(args.deadline.toString())

    if (args.tokenIn.isNative) {
      return {
        to: UNI_V2_ROUTER,
        data: iface.encodeFunctionData('swapExactETHForTokensSupportingFeeOnTransferTokens', [
          minOut,
          path,
          args.account,
          deadline
        ]),
        value: amountIn
      }
    }

    if (args.tokenOut.isNative) {
      return {
        to: UNI_V2_ROUTER,
        data: iface.encodeFunctionData('swapExactTokensForETHSupportingFeeOnTransferTokens', [
          amountIn,
          minOut,
          path,
          args.account,
          deadline
        ]),
        value: ethers.constants.Zero
      }
    }

    return {
      to: UNI_V2_ROUTER,
      data: iface.encodeFunctionData('swapExactTokensForTokensSupportingFeeOnTransferTokens', [
        amountIn,
        minOut,
        path,
        args.account,
        deadline
      ]),
      value: ethers.constants.Zero
    }
  }
}
